<template>
  <div class="buying-tickets-main">
      <!-- 选择城市 -->
    <div class="select-city">
        <h4>请选择所在城市</h4>
        <div @click="selectCityShow=true" class="input">{{text}}</div>
    </div>
    <!-- 跳过 -->
    <span @click="$router.push('/buying_tickets_list')" class="tg">查看全部会场</span>
    <!--  -->
    <van-popup v-model="selectCityShow" position="bottom"  @close="pickerShowClick(false)" >
        <!-- <van-area  :area-list="areaList" :columns-num="3"  @cancel="selectCityShow=false" @confirm="cityCfm" /> -->
        <van-picker  show-toolbar  :columns="columns"  @confirm="cityCfm"  @cancel="selectCityShow=false" />
    </van-popup>
  </div>
</template>

<script>
import { productAll } from "@/api/be_myself"
import areaList from "@/utils/area";
import { shareCon } from "@/utils/wxconfig";
export default {
    data(){
        return{
            areaList, //省市数组
            text:'请选择参加所在城市',
            selectCityShow:false,
            columns:[]
        }
    },
    methods:{
      // 转base64
      b64Encode(str) {
          return window.btoa(encodeURIComponent(str));
      },
      /*
       *@Description: vue中mini-ui或vant popup与picker结合在iphone手机穿透问题
       *@MethodAuthor:  Zhang Xiao Guang
       *@Date: 2019-11-28 12:18:35
      */
      pickerShowClick(newval) {
        let self = this;
        if (newval) {
          document.getElementsByTagName("body")[0].addEventListener('touchmove', self.preventDefault, {
            passive: false
          }); //阻止默认事件
        } else {

          document.getElementsByTagName("body")[0].removeEventListener('touchmove', self.preventDefault, {
            passive: false
          }); //打开默认事件
        }
      },
        // 确认选择城市触发
      // cityCfm(picker) {
      //   this.text = picker[0].name + ' ' + picker[1].name;
      //   this.selectCityShow = false;
      //   this.$router.push({
      //     path:'/buying_tickets_list',
      //     query:{
      //       city:this.b64Encode(picker[0].name + '/' + picker[1].name)
      //     }
      //   });
      // },
        // 确认选择城市触发
      cityCfm(picker) {
        this.text = picker;
        this.selectCityShow = false;
        this.$router.push({
          path:'/buying_tickets_list',
          query:{
            city:this.b64Encode(picker)
          }
        });
      },
      pullData(){
        // 获取所有商品
        productAll({
          category_id:1,  //1做自己节  2选对
          status:1  // 1上架  2下架
        }).then((data)=>{
          if(data.error>0){
            this.$toast(data.detail);
            return
          }
          let arr = data.list.sort((a,b)=>{
            return a.province>b.province?1:-1
          })
          let temp = arr.map(v=>{
              return v.province + '/' + v.city
          });
          this.columns = Array.from(new Set(temp));
        })
        shareCon("beMyself", this);
      }
    },
    created(){
      this.pullData();
    }
}
</script>

<style lang="scss" scoped>
.buying-tickets-main{
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: url('../../../assets/be-myself/2020/bg.png') center no-repeat;
    background-size: 100% 100%;
    .tg{
        position: absolute;
        right:40px;
        top: 40px;
        font-size:28px ;
        color: #E0E0E0;
    }
    .select-city{
        margin: 400px auto auto;
        text-align: center;
        h4{
            font-size:44px;
            color: #ffffff;
            line-height: 1;
            font-weight: bold;
            margin-bottom: 165px;
        }
        .input{
            margin: 0 auto;
            width: 606px;
            line-height: 100px;
            background: rgba(255, 255, 255, 0);
            border-radius: 53px;
            border: 2px solid #FFFFFF;
            padding:0px 30px;
            font-size: 28px;
            color:#E0E0E0;
        }

    }
}
</style>